import ReturnsPage from '../pages/returns-page.vue'

export default [
  {
    component: ReturnsPage,
    name: 'attaching.returns',
    path: '/:slug/attaching/returns',
  },
]
